import ImportMapping from "@mapmycustomers/shared/types/imports/ImportMapping";

const getMissedFileColumns = (mapping: ImportMapping, headers: string[] = []): string[] =>
  Object.values(mapping).filter((mappingValue) => !headers.includes(mappingValue));

export default getMissedFileColumns;
